import React from 'react';
import {
  ImageSlider,
  CollectionList,
  FeatureRow,
  ImageBar,
  FeatureColumns,
  CustomContent,
} from '@components/shopify';
import shopifyThemeSettings from '../../shopifyThemeSettings.json';

const CDN_URL = process.env.GATSBY_SHOPIFY_CDN_URL;

export const getHomepageSections = () => {
  const parsedData = JSON.parse(shopifyThemeSettings.asset.value);
  const contentForHomepage = parsedData.current.content_for_index;
  const homepageSections = {};
  contentForHomepage.forEach(sectionId => {
    homepageSections[sectionId] = parsedData.current.sections[sectionId];
  });
  return homepageSections;
};

const shopifyBlockToReact = (_, block) => {
  switch (block.type) {
    case 'image': {
      return {
        original: block.settings.image?.replace(
          'shopify://shop_images/',
          CDN_URL
        ),
        thumbnail: block.settings.image?.replace(
          'shopify://shop_images/',
          CDN_URL
        ),
        originalAlt:
          block.settings.button_label || 'Kurgo Dog Products Slider Image',
        mobileImage: block.settings?.mobileImage?.replace(
          'shopify://shop_images/',
          CDN_URL
        ),
        link:
          block?.settings?.button_link
            ?.replace('shopify://collections/', '/')
            ?.replace('shopify://products/', '/')
            ?.replace('shopify://pages/', '/')
            ?.replace('shopify://blogs/news', '/blog')
            ?.replace('shopify://policies', '/') ||
          block?.settings?.link
            ?.replace('shopify://collections/', '/')
            ?.replace('shopify://products/', '/')
            ?.replace('shopify://pages/', '/')
            ?.replace('shopify://blogs/news', '/blog')
            ?.replace('shopify://policies', '/') ||
          undefined,
        cta_label: block.settings.cta_label || '',
        slide_title: block?.settings?.slide_title,
        subheading: block?.settings?.subheading,
        button_label: block?.settings?.button_label,
        textColor: block?.settings?.textColor,
        boxColor: block?.settings?.boxColor,
        boxTransparency: block?.settings?.boxTransparency,
        scheduledSlideEnabled: block?.settings?.scheduledSlideEnabled,
        startDate: block?.settings?.startDate,
        endDate: block?.settings?.endDate,
        enable_image: block?.settings?.enable_image,
        boxVerticalAlignment: block?.settings?.boxVerticalAlignment,
        boxHorizontalAlignment: block?.settings?.boxHorizontalAlignment,
      };
    }

    case 'featured_collection': {
      return block.settings.collection;
    }

    case 'text': {
      return block.settings;
    }

    case 'text_block': {
      return block.settings;
    }

    default: {
      return {};
    }
  }
};

export const shopifySectionToReact = (sectionId, shopifySection) => {
  const blocks = {};

  if (shopifySection.block_order) {
    shopifySection.block_order.forEach(blockId => {
      blocks[blockId] = shopifySection.blocks[blockId];
    });
  }

  const shopifyBlocks = Object.keys(blocks).map(blockId =>
    shopifyBlockToReact(blockId, blocks[blockId])
  );

  switch (shopifySection.type) {
    case 'slideshow': {
      return (
        <ImageSlider
          key={`slideshow-${sectionId}`}
          items={shopifyBlocks}
          settings={shopifySection.settings}
        />
      );
    }
    case 'image-bar': {
      return <ImageBar key={`image-bar-${sectionId}`} items={shopifyBlocks} />;
    }
    case 'custom-content': {
      return (
        <CustomContent
          key={`custom-content-${sectionId}`}
          items={shopifyBlocks}
        />
      );
    }
    case 'feature-columns': {
      return (
        <FeatureColumns
          key={`feature-columns-${sectionId}`}
          items={shopifyBlocks}
          settings={shopifySection.settings}
          CDN_URL={CDN_URL}
        />
      );
    }
    case 'feature-row': {
      return (
        <FeatureRow
          key={`feature-columns-${sectionId}`}
          settings={shopifySection.settings}
          CDN_URL={CDN_URL}
        />
      );
    }
    case 'collection-list': {
      return (
        <CollectionList
          key={`collection-list-${sectionId}`}
          items={shopifyBlocks}
          settings={shopifySection.settings}
        />
      );
    }
    default: {
      console.warn('Unknown Section Type', sectionId);
      return <div key={`unknown-section-${sectionId}`} />;
    }
  }
};
